/* eslint-disable max-len */
import React from "react";
import { Footer as FooterComponent } from '@emarketer/componentlibrary';
import {emConfig as  config } from "@/emConfiguration";



export const Footer: React.FC = () => {
  return <FooterComponent
    articlesServiceUrl={config.articlesServiceUrl}
    contentUrl={config.dynamicContentAssetUrl}
    emHomeUrl={config.iiHomeUrl}
    numbersUrl={config.numbersUrl}
    researchTopicsServiceUrl={config.researchTopicsUrl}
    searchServiceUrl={config.searchRootUrl}
    osfScriptUrl={config.osfScriptUrl}
  />;
};